export default "__VITE_ASSET__xLO6118s__"